__turbopack_context__.v({
  "shimmer": "Skeleton-module-scss-module__ALQqcq__shimmer",
  "skeleton": "Skeleton-module-scss-module__ALQqcq__skeleton",
});
